import { Button, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { useState } from "react";
import { Book, Compass, DollarSign, Image, Info, List, MinusCircle, Plus, Repeat } from "react-feather";

export const MenuOptions = ({ params, Actions }) => {
  const { idvehicle} = params.data;

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const {handleClickShowVehicleImages, handleClickShowVehicleExpense, handleClickShowVehicleStatus} = Actions

  return (
    <>
      <Button 
        startIcon = { <List/>}
        variant='contained'
        size='small' 
        color='success'
        sx={{ marginRight: '8px' }}
        onClick={handleMenuOpen} 
        style={ { width: 150 } }
        > 
        Opciones
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
      >
        <MenuItem 
          onClick={()=>{
            handleClickShowVehicleImages(idvehicle)
            handleMenuClose()
          }}
        >
          <ListItemIcon> <Image color="black"/> </ListItemIcon>
          <ListItemText primary="Imagenes" />
        </MenuItem>

        <MenuItem 
          onClick={()=>{
            handleClickShowVehicleExpense(idvehicle)
            handleMenuClose()
          }}
        >
          <ListItemIcon> <DollarSign color="black"/> </ListItemIcon>
          <ListItemText primary="Gastos" />
        </MenuItem>
        

        <MenuItem 
          onClick={()=>{
            handleClickShowVehicleStatus(idvehicle)
            handleMenuClose()
          }}
        >
          <ListItemIcon> <Compass color="black"/> </ListItemIcon>
          <ListItemText primary="Estado - Ubicacion" />
        </MenuItem>
      </Menu>
    </>
  );
};
